import { Component, Input, OnInit } from '@angular/core';

import { IKeyValuePair } from '@services/registrations/registrations.models';
import { DialogService } from '@services/dialog/';

import { ViewUserDetailsComponent } from './../view-user-details/view-user-details.component';
import { ViewBikeDetailsComponent } from './../view-bike-details/view-bike-details.component';

@Component({
	selector: 'app-info-section',
	templateUrl: './info-section.component.html',
	styleUrls: ['./info-section.component.scss']
})
export class InfoSectionComponent implements OnInit {
	@Input() header: string;
	@Input() details: IKeyValuePair[];

	constructor(
		private dialogService: DialogService
	) { }

	ngOnInit(): void {
	}

	viewDetailsFor(view: string, id: string): void {
		switch(view) {
			case 'userId':
			case 'sourceUserIdentifier':
			case 'destinationUserIdentifier':
				this.dialogService.open(ViewUserDetailsComponent, {
					data: {
						user: {id: id},
						callback: (requestId: string) => {
						}
					}
				});
				break;

			case 'bikeId':
				this.dialogService.open(ViewBikeDetailsComponent, {
					data: {
						id: id,
						callback: (requestId: string) => {
						}
					}
				});
				break;
		}
	}
}
